import React from "react";
import PropTypes from "prop-types";
import ScrollableTabs from "../../../components/TabPanel/index";
import {
  triggerFetchDistributionTable,
  triggerRDSAPI,
} from "../../../redux/actions/homeAction";

const DeviceSalesDistribution = (props) => {
  const {
    data: {
      secTilesMasterTxDtos: tilesDto = [],
      isSectionActive = "",
      sectionName,
    },
    timeStampArr,
    ...other
  } = props;

  if (isSectionActive === "Y") {
    if (tilesDto.length) {
      return (
        <ScrollableTabs
          sectionHeader={sectionName}
          section={sectionName}
          tabsDto={tilesDto}
          sortingProperty="tileId"
          sortingOrder="asc"
          tabVariant="fullWidth"
          color="#7caeea"
          triggerFetchDistributionTable={triggerFetchDistributionTable}
          triggerRDSAPI={triggerRDSAPI}
          timeStampArr={timeStampArr}
          {...other}
          {...other}
        />
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

DeviceSalesDistribution.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};

export default DeviceSalesDistribution;
